import { DatePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment';
import { NgxPermissionsService } from 'ngx-permissions';
import { lastValueFrom, skip } from 'rxjs';
import { Apps } from 'src/app/enum/enum';
import { UserserviceService } from 'src/app/Services/userservice.service';
import { DynamicTranslationService } from '../../../dynamic-translation.service';
import {
  AIPricing,
  BrandModels,
  Labels,
  LicenseplateItems,
  LicensePlateItemSerial,
  LoginModel,
  production,
  ProductionHistory,
  Scrape,
  UserPermissionsModel
} from '../../../Models/ApplicationModels';
import { QzTrayService } from '../../../qz-tray.service';
import { BreadcrumbService } from '../../../Services/breadcrumb.service';
import { CustomToastsService } from '../../../Services/custom-toasts.service';
import { LabelaryService } from '../../../Services/labelary.service';
import { MasterDataSeriveService } from '../../../Services/master-data-serive.service';
import { TranslationCommunicationServiceService } from '../../../translation-communication-service.service';
import { TranslationService } from '../../../translation.service';
import { GoogleTranslateService } from '../../../Services/google-translate.service';
import { LabelEntityType } from 'src/app/Services/enum';

@Component({
  selector: 'app-production',
  templateUrl: './production.component.html',
  styleUrls: ['./production.component.css']
})
export class ProductionComponent {
  @ViewChild('checkBtn') checkBtn?: ElementRef<HTMLElement>;
  @ViewChild('myButton') myButton?: ElementRef<HTMLElement>;
  @ViewChild('closeBtn') closeBtn?: ElementRef<HTMLElement>;
  @ViewChild('tagButton') tagButton?: ElementRef<HTMLElement>;
  @ViewChild('priceTagBtn') priceTagBtn?: ElementRef<HTMLElement>;
  @ViewChild('productionLimitBtn') productionLimitBtn?: ElementRef<HTMLElement>;

  printersList: Array<string> = [];
  result: any;
  quantity: any = 1;
  piece: any = 1;
  PrintMode: boolean = false;
  reprintMode: boolean = false;
  brands: Array<BrandModels> = [];
  brandsForSearch: Array<BrandModels> = [];
  brandID: number = 0;
  isBrandTypeId: boolean = true;
  activeBin: string = '';
  scrapeResult: Array<Scrape> = [];
  sizeButtons: any;
  labels: any;
  priceTags: any;
  selectionlabels: any;
  priceTagStatus: number | null = 0;
  activeCondition: number = 0;
  categoriesDetails: any;
  departmentName: any;
  isPricetype: boolean = true;
  isCondition: boolean = false;
  price: number = 0;
  isSizedNull: boolean = false;
  selectedPriceTagId: number | null = null;
  lablesData: any = '';
  conditions: any;
  sizeID: number = 0;
  showConditions: boolean = true;
  showQualityBox: boolean = true;
  showPrices: boolean = true;
  showSubmit: boolean = true;
  inputValue: string = '';
  alphasize: string = '';
  priceTagDescrListinEnglish: any[] = [];
  translatedPropertyBindedTexts: string[] = [];
  translatedFormatValue: string = '';
  formatLabelsListinEnglish: any[] = [];
  labelsDataDeptDecrInEnglish: any[] = [];
  labelsDataCategoryNameInEnglish: any[] = [];
  labelsDataDeptDecrObjInEnglish: string = '';
  categoryNameObj: string = '';
  conditionsDescrInEnglish: any[] = [];
  brandsDescrInEnglish: any[] = [];
  categoryDetails: any;
  categoryId: number = 0;
  deptDetails: any;
  deptDescrp: any;
  categoryName: any;
  updatedFavoritesList: any;
  hideSizeGried: boolean = true;
  hideconditionGrid: boolean = true;
  activeTag: number = 0;
  activeButtonIndex: any = 0;
  activeQuality: any = 0;
  scrapeResult1: any;
  searchQuery: string = '';
  searchQuery1: string = '';
  averagePrice: any;
  selectedBrandDescription: string = '';
  selectedBrand: number = 0;
  inputVal: any;
  SerialId: string = '123456';
  TranslatedTitled: string = '';
  ctgName: any;
  abd: any = '';
  ctg: any = '';
  translatedTexts: string[] = [];
  isSpecialPrice = false;
  productionPrint: any;
  CategoryDataFromFavList: any;
  formatLabels: Array<Labels> = [];
  deptId: any;
  numSize: any;
  userData: any;
  originalDeptName: any = '';
  originalCtgName: any = '';
  originalsubCtgName: any = '';
  deptNameFromFav: any = '';
  showPriceField: boolean = true;
  productionWorking: production = new production();
  productionHistory: ProductionHistory = new ProductionHistory();
  getHistory: Array<ProductionHistory> = [];
  printHistory: Array<ProductionHistory> = [];
  selectedLanguage: string = 'en'; // Default language
  offTranslationKey: string = 'OFF_TRANSLATION_KEY';
  onTranslationKey: string = 'ON_TRANSLATION_KEY';
  moveToBin: boolean = false;
  price2: number = 0;
  brandname: string = '';
  showModal: boolean = false;
  tagClr: string = '';
  tagDept: string = '';
  tagCtg: string = '';
  tagSize: string = '';
  tagPrice: string = '';
  tagID: number = 0;
  subCategoryID: number = 0;
  productionCycleID: number = 0;
  isStayScreen: boolean = false;
  isPrintPreview: boolean = false;
  modalDesc: string = '';
  aiPrice: AIPricing = new AIPricing();
  zplCode: string = '';
  showMoreSizes: boolean = true;
  showMorePriceTags: boolean = true;
  newConditions: any[] = [];
  selectedBrandName: string = 'Select Brand';
  brandSearch: string = '';
  printerType: number = 0;
  labelImg: string = '';
  previewZplCode: string = '';
  previewTagSize: string = '';
  originalStoreID: any;
  userDetails: any;
  keepSelection: boolean = false;
  productionCycleScheduleID: number = 0;
  licensePlateItem: LicenseplateItems = new LicenseplateItems();
  isOverride: boolean = false;
  overrideDetails: any;
  itemSerialNumber: LicensePlateItemSerial = new LicensePlateItemSerial();
  userInfo: LoginModel = new LoginModel();
  productionLimitPopupMsg: string = '';
  sourceBinId: number = 0;

  constructor(
    private permissionService: NgxPermissionsService,
    private userservice: UserserviceService,
    private cdr: ChangeDetectorRef,
    private labelaryService: LabelaryService,
    private masterservice: MasterDataSeriveService,
    private toastr: CustomToastsService,
    public translationService: TranslationService,
    private dynamicTranslationService: DynamicTranslationService,
    private translationCommunicationService: TranslationCommunicationServiceService,
    private breadcrumbService: BreadcrumbService,
    private printService: QzTrayService,
    private datePipe: DatePipe,
    private route: Router,
    private googleTranslateService: GoogleTranslateService
  ) { }

  ngOnInit() {
    this.productionID();
    this.getProductionBin();
    this.printService.initQZ();
    this.getPrintersList();
    this.categoryDetails = JSON.parse(
      localStorage.getItem('CategoryDetails') || '{}'
    );
    this.isOverride = localStorage.getItem('isOverride') === 'true';
    this.overrideDetails = JSON.parse(
      localStorage.getItem('overrideDetails') || '{}'
    );

    this.CategoryDataFromFavList = JSON.parse(
      localStorage.getItem('CategoryData') || '{}'
    );
    this.deptDetails = JSON.parse(localStorage.getItem('deptID') || '{}');
    this.originalCtgName =
      this.categoryDetails.categoryName ||
      this.deptDetails.categoryName ||
      this.CategoryDataFromFavList.categoryName;
    this.originalDeptName =
      this.deptDetails.departmentDescr ||
      this.categoryDetails.departmentDescr ||
      this.CategoryDataFromFavList.departmentDescr;

    if (this.CategoryDataFromFavList.categoryId > 0) {
      localStorage.removeItem('CategoryDetails');
      this.categoryDetails = {};
      this.ctgName = this.CategoryDataFromFavList.categoryName;
      this.categoryId = this.CategoryDataFromFavList.categoryId;
      this.categoryName = this.CategoryDataFromFavList.categoryName;
      this.departmentName =
        this.deptDetails.descriptionTranslated ||
        this.deptDetails.departmentDescr;
    } else {
      localStorage.removeItem('CategoryData');
      this.ctgName = this.categoryDetails.categoryName;
      this.categoryId =
        this.categoryDetails.categoryId || this.categoryDetails.categoryId;
      this.categoryName = this.categoryDetails.categoryName;
      this.departmentName = this.deptDetails.departmentDescr;
    }

    this.breadcrumbService.updateActiveCategoryTab(this.categoryName);
    this.activeDepartment();
    this.breadcrumbService.updateActiveDeptTab(this.departmentName);

    this.translationCommunicationService
      .getSelectedLanguage()
      .pipe(skip(1))
      .subscribe((language) => {
        this.selectedLanguage = language;
        this.translateTextTitle(this.departmentName);
        this.translateCtgTitle(this.ctgName);
        this.translateText(this.priceTagDescrListinEnglish);
        this.translateConditiondescr(this.conditionsDescrInEnglish);
        this.translateBranddescr(this.brandsDescrInEnglish);
        this.translateFormatTypeDescrp(this.formatLabelsListinEnglish);
        this.translateLabelsDataCategoryName(
          this.labelsDataCategoryNameInEnglish
        );
        this.translateDataDeptDecrObj(this.labelsDataDeptDecrObjInEnglish);
        this.translateCategoryNameObj(this.categoryNameObj);
      });

    this.getAllData();
    this.getBrands();
    this.getPermissionsByUserId();

    this.deptDescrp = this.deptDetails.departmentDescr;
    this.updatedFavoritesList = JSON.parse(
      localStorage.getItem('updatedFavoritesLists') || '[]'
    );

    const matchingDept = this.updatedFavoritesList.find(
      (item: any) =>
        item.departmentId === this.deptDetails.departmentId ||
        (this.deptDetails.departmentId &&
          item.categoryId === this.deptDetails.categoryId)
    );

    let titileName: any =
      (matchingDept?.departmentDescr || '') +
      ':' +
      (this.deptDetails?.categoryName || '');
    this.deptDescrp = matchingDept?.departmentDescr || '';

    this.deptNameFromFav = JSON.parse(
      localStorage.getItem('deptNameFromFav') || '{}'
    );
    const ctgnamefromsubdeptStr = localStorage.getItem('ctgnamefromsubdept');
  }

  async productionID() {
    this.userDetails = await this.masterservice.getUserDetailsFromStorage();
    this.isStayScreen = this.userDetails.productionStayScreen;
    this.isPrintPreview = this.userDetails.printPreview;
    const productionDataRaw = localStorage.getItem('productionCycle');
    let productionData: any = null;

    try {
      productionData = productionDataRaw ? JSON.parse(productionDataRaw) : null;
    } catch {
      productionData = null;
    }

    const cycleData = Array.isArray(productionData)
      ? productionData[0]
      : productionData;

    if (cycleData?.productionCycleId) {
      this.productionCycleID = Number(cycleData.productionCycleId) || 0;
    }

    if (cycleData?.productionCycleScheduleId) {
      this.productionCycleScheduleID =
        Number(cycleData.productionCycleScheduleId) || 0;
    }

    if (this.productionCycleID == 0) this.productionCycleID = 1;
  }

  async getProductionBin() {
    //production bin id
    const binId = localStorage.getItem('ProductionBinId');

    if (binId && !isNaN(Number(binId))) {
      this.sourceBinId = Number(binId);
    }
  }
  async moveBin() {
    this.moveToBin = true;
    let binData: production = new production();
    let user = this.masterservice.getUserDetailsFromStorage();
    let storeId = JSON.parse(localStorage.getItem('tempStoreId')!);
    if (!storeId) {
      storeId = JSON.parse(localStorage.getItem('storeId')!);
    }

    let result = this.result.item2[0];
    binData.brandID = this.selectedBrand;
    binData.price = this.inputVal;
    binData.CategoryID = result.CategoryID;
    binData.subCategoryID = this.subCategoryID;
    binData.departmentId = result.DepartmentID;
    binData.userID = user.userId;
    binData.productionStoreId = storeId;
    binData.CompanyID = user.companyID;
    binData.qty = this.quantity;
    binData.addtoBin = true;
    binData.numberOfPieces = this.piece;
    binData.productionCycleID = this.productionCycleID;
    binData.productionCycleScheduleID = this.productionCycleScheduleID;
    this.brandname = this.getBrandName(this.selectedBrand);
    await this.onProduceClick(binData);
  }

  async getPrintersList() {
    await this.printService.getPrinters().subscribe((res) => {
      this.printersList = res as string[];
    });
  }

  async printLabel(data: any) {
    let printerName: string = '';

    if (this.printerType == 1) {
      printerName = 'ZebraLabel';
    } else if (this.printerType == 2) {
      printerName = 'ZebraTag';
    } else if (this.printerType == 3) {
      printerName = 'ZebraBoth';
    }
    let res = this.printService.printData(printerName, data);
  }
  chekPrice() {
    this.triggerPriceBtn();
  }
  generateZPLTag(
    name: string,
    category: string,
    price: string,
    barcode: string
  ): string[] {
    const zplTemplate: string[] = [
      '^XA',
      '~TA000',
      '~JSN',
      '^LT0',
      '^MNW',
      '^MTD',
      '^PON',
      '^PMN',
      '^LH0,0',
      '^JMA',
      '^PR4,4',
      '~SD15',
      '^JUS',
      '^LRN',
      '^CI27',
      '^PA0,1,1,0',
      '^XZ',
      '^XA',
      '^MMT',
      '^PW406',
      '^LL203',
      '^LS0',
      `^FT29,45^A0N,37,38^FH^CI28^FD${name}^FS^CI27`,
      `^FT29,86^A0N,28,28^FH^CI28^FD${category}^FS^CI27`,
      `^FT29,155^A0N,37,38^FH^CI28^FD$ ${price}^FS^CI27`,
      `^FT280,181^A0N,17,18^FH^CI28^FD${barcode}^FS^CI27`,
      '^FT268,150^BON,5,8',
      `^FH^FD${barcode}^FS`,
      '^PQ1,0,1,Y',
      '^XZ'
    ];
    return zplTemplate;
  }

  generateEcomTag(
    department?: string,
    category?: string,
    brand?: string,
    price?: string,
    price2?: string,
    qty?: string
  ): string[] {
    const zplTemplate: string[] = [
      '^XA',
      '~TA000',
      '~JSN',
      '^LT0',
      '^MNW',
      '^MTD',
      '^PON',
      '^PMN',
      '^LH0,0',
      '^JMA',
      '^PR4,4',
      '~SD15',
      '^JUS',
      '^LRN',
      '^CI27',
      '^PA0,1,1,0',
      '^XZ',
      '^XA',
      '^MMT',
      '^PW305',
      '^LL508',
      '^LS0',
      `^FT44,150^A0N,28,28^FH^CI28^FDE-Commerce^FS^CI27`,
      `^FT44,200^A0N,22,22^FH^CI28^FD${department}/${category}^FS^CI27`,
      `^FT44,250^A0N,28,28^FH^CI28^FD${brand}^FS^CI27`,
      `^FT44,300^A0N,22,22^FH^CI28^FDGoodwill Finds $${price} ^FS^CI27`,
      `^FT44,335^A0N,22,22^FH^CI28^FDRCS AI Avg^FS^CI27`,
      `^FT185,335^A0N,22,22^FH^CI28^FD $ ${price2} ^FS^CI27`,
      `^FT44,400^A0N,22,22^FH^CI28^FDCurent OnHand^FS^CI27`,
      `^FT185,400^A0N,22,22^FH^CI28^FD: ${qty} ^FS^CI27`,
      '^PQ1,0,1,Y',
      '^XZ'
    ];
    this.printLabel(zplTemplate);
    return zplTemplate;
  }

  generateBoutiqueTag(
    department?: string,
    category?: string,
    brand?: string,
    price?: string,
    storeId?: string,
    qty?: string
  ): string[] {
    const zplTemplate: string[] = [
      '^XA',
      '~TA000',
      '~JSN',
      '^LT0',
      '^MNW',
      '^MTD',
      '^PON',
      '^PMN',
      '^LH0,0',
      '^JMA',
      '^PR4,4',
      '~SD15',
      '^JUS',
      '^LRN',
      '^CI27',
      '^PA0,1,1,0',
      '^XZ',
      '^XA',
      '^MMT',
      '^PW305',
      '^LL508',
      '^LS0',
      `^FT44,150^A0N,28,28^FH^CI28^FDBoutique Item^FS^CI27`,
      `^FT44,200^A0N,22,22^FH^CI28^FD${department}/${category}^FS^CI27`,
      `^FT44,250^A0N,28,28^FH^CI28^FD${brand}^FS^CI27`,
      `^FT44,300^A0N,22,22^FH^CI28^FDStoreID ^FS^CI27`,
      `^FT134,300^A0N,22,22^FH^CI28^FDQty ^FS^CI27`,
      `^FT184,300^A0N,22,22^FH^CI28^FDAvg Price^FS^CI27`,
      `^FT34,335^A0N,22,22^FH^CI28^FD ${storeId} ^FS^CI27`,
      `^FT124,335^A0N,22,22^FH^CI28^FD ${qty} ^FS^CI27`,
      `^FT184,335^A0N,22,22^FH^CI28^FD $ ${price} ^FS^CI27`,
      '^PQ1,0,1,Y',
      '^XZ'
    ];
    this.printLabel(zplTemplate);
    return zplTemplate;
  }

  generateSpokane(
    company: string,
    dept: string,
    category: string,
    Size: string,
    price: string,
    barcode: string
  ) {
    if (Size) {
      const zpltemplate: string[] = [
        `^XA`,
        `~TA000`,
        `~JSN`,
        `^LT0`,
        `^MNW`,
        `^MTD`,
        `^PON`,
        `^PMN`,
        `^LH0,0`,
        `^JMA`,
        `^PR6,6`,
        `~SD15`,
        `^JUS`,
        `^LRN`,
        `^CI27`,
        `^PA0,1,1,0`,
        `^XZ`,
        `^XA`,
        `^MMT`,
        `^PW559`,
        `^LL203`,
        `^LS0`,
        `^FT53,46^A0N,28,30^FH\^CI28^FD${company}^FS^CI27`,
        `^FT28,76^A0N,23,28^FH\^CI28^FD${dept}^FS^CI27`,
        `^FT28,105^A0N,23,28^FH\^CI28^FD${category}^FS^CI27`,
        `^FT28,134^A0N,23,28^FH\^CI28^FDSize:${Size}^FS^CI27`,
        `^BY1,3,41^FT158,176^BCN,,Y,N`,
        `^FH\^FD>${barcode}^FS`,
        `^FT28,170^A0N,28,35^FH\^CI28^FD$${price}^FS^CI27`,
        `^FT322,47^A0N,28,30^FH\^CI28^FD${company}^FS^CI27`,
        `^FT298,77^A0N,23,28^FH\^CI28^FD${dept}^FS^CI27`,
        `^FT298,106^A0N,23,28^FH\^CI28^FD${category}^FS^CI27`,
        `^FT298,135^A0N,23,28^FH\^CI28^FDSize:${Size}^FS^CI27`,
        `^BY1,3,41^FT428,177^BCN,,Y,N`,
        `^FH\^FD>${barcode}^FS`,
        `^FT298,172^A0N,28,35^FH\^CI28^FD$${price}^FS^CI27`,
        `^PQ1,0,1,Y`,
        `^XZ`
      ];
      return zpltemplate;
    } else {
      let zplTemplate: string[] = [
        `^XA`,
        `~TA000`,
        `~JSN`,
        `^LT0`,
        `^MNW`,
        `^MTD`,
        `^PON`,
        `^PMN`,
        `^LH0,0`,
        `^JMA`,
        `^PR6,6`,
        `~SD15`,
        `^JUS`,
        `^LRN`,
        `^CI27`,
        `^PA0,1,1,0`,
        `^XZ`,
        `^XA`,
        `^MMT`,
        `^PW559`,
        `^LL203`,
        `^LS0`,
        `^FT53,46^A0N,28,30^FH\^CI28^FD${company}^FS^CI27`,
        `^FT28,76^A0N,23,28^FH\^CI28^FD${dept}^FS^CI27`,
        `^FT28,105^A0N,23,28^FH\^CI28^FD${category}^FS^CI27`,
        `^BY1,3,41^FT158,176^BCN,,Y,N`,
        `^FH\^FD>${barcode}^FS`,
        `^FT28,170^A0N,28,35^FH\^CI28^FD$1.99^FS^CI27`,
        `^FT322,47^A0N,28,30^FH\^CI28^FD${company}^FS^CI27`,
        `^FT298,77^A0N,23,28^FH\^CI28^FD${dept}^FS^CI27`,
        `^FT298,106^A0N,23,28^FH\^CI28^FD${category}^FS^CI27`,
        `^BY1,3,41^FT428,177^BCN,,Y,N`,
        `^FH\^FD>${barcode}^FS`,
        `^FT298,172^A0N,28,35^FH\^CI28^FD$1.99^FS^CI27`,
        `^PQ1,0,1,Y`,
        `^XZ`
      ];
      return zplTemplate;
    }
  }

  generateZPLLabel(
    company: string,
    department: string,
    category: string,
    size: string,
    price: string,
    barcode: string
  ): string[] {
    if (size != null) {
      const zplTemplate: string[] = [
        '^XA',
        '~TA000',
        '~JSN',
        '^LT0',
        '^MNW',
        '^MTD',
        '^PON',
        '^PMN',
        '^LH0,0',
        '^JMA',
        '^PR4,4',
        '~SD15',
        '^JUS',
        '^LRN',
        '^CI27',
        '^PA0,1,1,0',
        '^XZ',
        '^XA',
        '^MMT',
        '^PW305',
        '^LL508',
        '^LS0',
        `^FT35,57^A0N,37,38^FH^CI28^FD${company}^FS^CI27`,
        `^FT54,144^A0N,28,28^FH^CI28^FD${department}^FS^CI27`,
        `^FT90,200^A0N,28,28^FH^CI28^FD${category}^FS^CI27`,
        `^FT90,250^A0N,24,18^FH^CI28^FDSize : ^FS^CI27`,
        `^FT131,248^A0N,24,32^FH^CI28^FD${size} ^FS^CI27`,
        `^FT90,299^A0N,28,38^FH^CI28^FD$ ${price} ^FS^CI27`,
        `^FT102,406^A0N,17,18^FH^CI28^FD${barcode}^FS^CI27`,
        `^BY1,3,61^FT69,377^BCN,,N,N`,
        `^FH^FD>${barcode}^FS`,
        '^PQ1,0,1,Y',
        '^XZ'
      ];
      return zplTemplate;
    } else {
      const zplTemplate: string[] = [
        '^XA',
        '~TA000',
        '~JSN',
        '^LT0',
        '^MNW',
        '^MTD',
        '^PON',
        '^PMN',
        '^LH0,0',
        '^JMA',
        '^PR4,4',
        '~SD15',
        '^JUS',
        '^LRN',
        '^CI27',
        '^PA0,1,1,0',
        '^XZ',
        '^XA',
        '^MMT',
        '^PW305',
        '^LL508',
        '^LS0',
        `^FT35,57^A0N,37,38^FH^CI28^FD${company}^FS^CI27`,
        `^FT54,144^A0N,28,28^FH^CI28^FD${department}^FS^CI27`,
        `^FT90,200^A0N,28,28^FH^CI28^FD${category}^FS^CI27`,
        `^FT90,250^A0N,28,38^FH^CI28^FD$ ${price} ^FS^CI27`,
        `^FT102,370^A0N,17,18^FH^CI28^FD${barcode}^FS^CI27`,
        `^BY1,3,61^FT69,330^BCN,,N,N`,
        `^FH^FD>${barcode}^FS`,
        '^PQ1,0,1,Y',
        '^XZ'
      ];
      return zplTemplate;
    }
  }

  generateZPLLabelLandscape(
    company: string,
    department: string,
    category: string,
    size: string,
    price: string,
    barcode: string
  ): string[] {
    if (size != null) {
      const zplTemplate: string[] = [
        `^XA`,
        `~TA000`,
        `~JSN`,
        `^LT0`,
        `^MNW`,
        `^MTD`,
        `^PON`,
        `^PMN`,
        `^LH0, 0`,
        `^JMA`,
        `^PR6, 6`,
        `~SD15`,
        `^JUS`,
        `^LRN`,
        `^CI27`,
        `^PA0, 1, 1, 0`,
        `^XZ`,
        `^XA`,
        `^MMT`,
        `^PW508`,
        `^LL305`,
        `^LS0`,
        `^FT443,38^A0R,42,41^FH\^CI28^FD${company}^FS^CI27`,
        `^FT347,38^A0R,35,34^FH\^CI28^FD${department}^FS^CI27`,
        `^FT286,38^A0R,35,34^FH\^CI28^FD${category}^FS^CI27`,
        `^FT222,38^A0R,35,34^FH\^CI28^FDSize : ${size}^FS^CI27`,
        `^FT153,38^A0R,35,34^FH\^CI28^FDPrice : ^FS^CI27`,
        `^FT153,148^A0R,35,34^FH\^CI28^FD$^FS^CI27`,
        `^FT153,168^A0R,35,34^FH\^CI28^FD${price}^FS^CI27`,
        `^BY1,3,67^FT44,98^BCR,,Y,N`,
        `^FH\^FD>${barcode}^FS`,
        `^PQ1, 0, 1, Y`,
        `^XZ`
      ];
      return zplTemplate;
    } else {
      const zplTemplate: string[] = [
        `^XA`,
        `~TA000`,
        `~JSN`,
        `^LT0`,
        `^MNW`,
        `^MTD`,
        `^PON`,
        `^PMN`,
        `^LH0, 0`,
        `^JMA`,
        `^PR6, 6`,
        `~SD15`,
        `^JUS`,
        `^LRN`,
        `^CI27`,
        `^PA0, 1, 1, 0`,
        `^XZ`,
        `^XA`,
        `^MMT`,
        `^PW508`,
        `^LL305`,
        `^LS0`,
        `^FT443,38^A0R,35,34^FH\^CI28^FD${company}^FS^CI27`,
        `^FT347,38^A0R,35,34^FH\^CI28^FD${department}^FS^CI27`,
        `^FT286,38^A0R,35,34^FH\^CI28^FD${category}^FS^CI27`,
        `^FT222,38^A0R,35,34^FH\^CI28^FDPrice : ^FS^CI27`,
        `^FT222,148^A0R,35,34^FH\^CI28^FD$^FS^CI27`,
        `^FT222,168^A0R,35,34^FH\^CI28^FD${price}^FS^CI27`,
        `^BY1,3,67^FT103,98^BCR,,Y,N`,
        `^FH\^FD>${barcode}^FS`,
        `^PQ1, 0, 1, Y`,
        `^XZ`
      ];
      return zplTemplate;
    }
  }

  keepChanges() {
    this.keepSelection = !this.keepSelection;
    this.cdr.detectChanges();
  }

  generateZpl(
    CompanyName: string,
    Department: string,
    Category: string,
    SubCategory: string,
    SizeText: string = 'Size',
    SizeSize: string,
    Price: string,
    BarcodeValue: string,
    CompanyNameLine2: string,
    QualityID: number = 0,
    LabelIndex: string,
    Piece: string,
    Brand: string = ''
  ) {
    if (SizeSize == null || SizeSize == '') {
      SizeText = ' ';
    }
    let QualityDescr = '';
    this.priceTags.forEach((item: any) => {
      if (item.QualityID == QualityID) {
        QualityDescr = item.QualityDescr;
      }
    });
    if (Department == Category) {
      Category = ' ';
    }
    function safeParse(value: string | null): string {
      try {
        return value ? JSON.parse(value) : '';
      } catch {
        return value ?? '';
      }
    }

    let storeRaw =
      localStorage.getItem('storeName') ??
      localStorage.getItem('defaultStoreName') ??
      '';
    let Store: string = safeParse(storeRaw);

    let Color = '';
    let WeekNumber = '';

    try {
      const colorsRaw = localStorage.getItem('productionCycle');
      const parsedColors = colorsRaw ? JSON.parse(colorsRaw) : null;
      const cycle = Array.isArray(parsedColors)
        ? parsedColors[0]
        : parsedColors;
      Color =
        cycle?.productionDisplayName ||
        cycle?.displayName ||
        this.userDetails?.productionCycle ||
        '';
      WeekNumber = cycle?.weekNumber || '';
    } catch {
      Color = this.userDetails?.productionCycle || '';
      WeekNumber = '';
    }

    const futproductionCycle = localStorage.getItem('FutureProductionCycle');

    if (futproductionCycle) {
      try {
        let futprod = JSON.parse(futproductionCycle);
        if (futprod) {
          Color = futprod.displayName || Color;
          WeekNumber = futprod.weekNumber || WeekNumber;
        }
      } catch { }
    }

    if (
      Brand == null ||
      Brand == undefined ||
      Brand == 'None' ||
      Brand == 'Select Brand'
    ) {
      Brand = '';
    }

    let Date = '-';
    let Date2 = '-';
    const currentDate = moment();
    Date = currentDate.format('MM/DD');
    Date2 = currentDate.format('MM/DD/YYYY');

    const Time = currentDate.format('HH:mm');

    let userStorageData = this.masterservice.getUserDetailsFromStorage();
    const User = userStorageData?.brijjusername || '';
    const DisplayName = userStorageData?.displayName || '';

    if (typeof this.previewZplCode !== 'string') {
      console.error('Invalid or missing ZPL code');
      return [];
    }
    this.formatLabels.map((res) => {
      if (res.id == this.activeTag) {
        this.previewZplCode = res.zplCode;

        this.previewTagSize = this.extractLabelSize(res.name);
      }
    });
    const replacedZplCode = this.previewZplCode
      .replace(/\${CompanyName}/g, CompanyName ? CompanyName : '')
      .replace(/\${Color}/g, Color ? Color : '')
      .replace(/\${WeekNumber}/g, WeekNumber ? WeekNumber : '')
      .replace(/\${Department}/g, Department ? Department : '')
      .replace(/\${Category}/g, Category ? Category : '')
      .replace(/\${SubCategory}/g, SubCategory ? SubCategory : '')
      .replace(/\${SizeText}/g, SizeText ? SizeText : '')
      .replace(/\${SizeSize}/g, SizeSize ? SizeSize : '')
      .replace(/\${Price}/g, Price ? Price : '')
      .replace(/\${Date}/g, Date ? Date : '')
      .replace(/\${Date2}/g, Date2 ? Date2 : '')
      .replace(/\${Time}/g, Time)
      .replace(/\${User}/g, User)
      .replace(/\${Name}/g, DisplayName)
      .replace(/\${DisplayName}/g, DisplayName)
      .replace(/\${BarcodeValue}/g, BarcodeValue ? BarcodeValue : '')
      .replace(/\${Store}/g, Store ? Store : '')
      .replace(/\${Quality}/g, QualityDescr ? QualityDescr : '')
      .replace(/\${LabelIndex}/g, LabelIndex ? LabelIndex : '')
      .replace(/\${Piece}/g, Piece ? Piece : '')
      .replace(/\${Brand}/g, Brand ? Brand : '')
      .replace(
        /\${CompanyNameLine2}/g,
        CompanyNameLine2 ? CompanyNameLine2 : ''
      );

    const zplTemplate: string[] = replacedZplCode
      .split('\n')
      .map((line) => line.trim());
    return zplTemplate;
  }

  generatePreviewZpl(
    CompanyName: string,
    Department: string,
    Category: string,
    SizeText: string = 'Size',
    SizeSize: string,
    Price: string,
    BarcodeValue: string,
    CompanyNameLine2: string,
    QualityID: number = 0,
    BrandName: string = ''
  ) {
    if (SizeSize == null) {
      SizeText = ' ';
    }
    if (Department == Category) {
      Category = ' ';
    }
    let QualityDescr = '';
    this.priceTags.forEach((item: any) => {
      if (item.qualityId == QualityID) {
        QualityDescr = item.qualityDescr;
      }
    });

    function safeParse(value: string | null): string {
      try {
        return value ? JSON.parse(value) : '';
      } catch {
        return value ?? '';
      }
    }

    let storeRaw =
      localStorage.getItem('storeName') ??
      localStorage.getItem('defaultStoreName') ??
      '';
    let Store: string = safeParse(storeRaw);

    let Color = '';

    try {
      const colorsRaw = localStorage.getItem('productionCycle');
      const parsedColors = colorsRaw ? JSON.parse(colorsRaw) : null;
      const cycle = Array.isArray(parsedColors)
        ? parsedColors[0]
        : parsedColors;
      Color =
        cycle?.productionDisplayName ||
        cycle?.displayName ||
        this.userDetails?.productionCycle ||
        '';
    } catch {
      Color = this.userDetails?.productionCycle || '';
    }
    let Date = '-';
    let Date2 = '-';
    const currentDate = moment();
    Date = currentDate.format('MM/DD');
    Date2 = currentDate.format('MM/DD/YYYY');

    const Time2 = currentDate.format('HH:mm');

    let userStorageData2 = this.masterservice.getUserDetailsFromStorage();
    const User2 = userStorageData2?.brijjusername || '';
    const DisplayName2 = userStorageData2?.displayName || '';

    let Brand = BrandName;

    if (
      BrandName == null ||
      BrandName == undefined ||
      BrandName == 'None' ||
      BrandName == 'Select Brand'
    ) {
      BrandName = '';
      Brand = 'Brand';
    }

    if (typeof this.previewZplCode !== 'string') {
      console.error('Invalid or missing ZPL code');
      return [];
    }
    this.formatLabels.map((res) => {
      if (res.id == this.activeTag) {
        this.previewZplCode = res.zplCode;

        this.previewTagSize = this.extractLabelSize(res.name);
      }
    });
    const replacedZplCode = this.previewZplCode
      .replace(/\${CompanyName}/g, CompanyName ? CompanyName : '')
      .replace(/\${Color}/g, Color ? Color : '')
      .replace(/\${Department}/g, Department ? Department : '')
      .replace(/\${Category}/g, Category ? Category : '')
      .replace(/\${SizeText}/g, SizeText ? SizeText : '')
      .replace(/\${SizeSize}/g, SizeSize ? SizeSize : '')
      .replace(/\${Price}/g, Price ? Price : '')
      .replace(/\${Date}/g, Date ? Date : '')
      .replace(/\${Date2}/g, Date2 ? Date2 : '')
      .replace(/\${Time}/g, Time2)
      .replace(/\${User}/g, User2)
      .replace(/\${Name}/g, DisplayName2)
      .replace(/\${DisplayName}/g, DisplayName2)
      .replace(/#/g, '%23')
      .replace(/\${BarcodeValue}/g, BarcodeValue ? BarcodeValue : '')
      .replace(/\${Store}/g, Store ? Store : '')
      .replace(/\${Quality}/g, QualityDescr ? QualityDescr : '')
      .replace(/\${Brand}/g, Brand ? Brand : '')
      .replace(
        /\${CompanyNameLine2}/g,
        CompanyNameLine2 ? CompanyNameLine2 : ''
      );

    // Split the ZPL code into an array of lines
    const zplTemplate: string[] = replacedZplCode
      .split('\n')
      .map((line: string) => line.trim());

    return zplTemplate;
  }

  showSuccess() {
    this.toastr.success('New Price has been successfully added.');
  }

  showReprint() {
    this.toastr.success('Printing');
  }

  showDeleted() {
    this.toastr.success('Last item entry has been successfully deleted.');
  }

  showError() {
    this.toastr.error('Price Not Added');
  }

  showPriceError() {
    this.toastr.error('Price Not Selected');
    this.resetButtons();
  }

  showPrintError() {
    this.resetButtons();
    this.toastr.error('No Data Found!');
  }

  activeDepartment() {
    this.deptDetails = JSON.parse(localStorage.getItem('deptID') || '{}');
    this.deptId =
      this.deptDetails.departmentId || this.deptDetails.departmentId;
    this.masterservice.getDepartmentById(this.deptId).subscribe((res: any) => {
      this.breadcrumbService.updateActiveDeptTab(res.departmentDescr);
      this.modalDesc = res.departmentDescr;
    });
  }

  async updateBreadCrumb() {
    this.categoryName = this.ctgName;
    this.breadcrumbService.updateActiveCategoryTab(this.categoryName);
    this.deptDetails = JSON.parse(localStorage.getItem('deptID') || '{}');
    this.departmentName = this.deptDetails.departmentDescr;
    this.breadcrumbService.updateActiveDeptTab(this.departmentName);
  }

  getAllData(): void {
    let dept: any = JSON.parse(localStorage.getItem('deptID') || '{}');
    let departmentIdToUse =
      dept.departmentId !== undefined ? dept.departmentId : dept.departmentId;
    let userdata = this.masterservice.getUserDetailsFromStorage();

    let categoryDetails = JSON.parse(localStorage.getItem('CategoryDetails')!);
    if (categoryDetails == null) {
      categoryDetails = JSON.parse(localStorage.getItem('CategoryData')!);
    }

    this.subCategoryID = 0;

    if (categoryDetails) {
      if (categoryDetails.subCategoryID !== undefined) {
        this.subCategoryID = categoryDetails.subCategoryID;
      } else if (categoryDetails.subCategoryId !== undefined) {
        this.subCategoryID = categoryDetails.subCategoryId;
      }

      if (
        this.subCategoryID === 0 &&
        categoryDetails.subCategoryId !== undefined
      ) {
        this.subCategoryID = categoryDetails.subCategoryId;
      } else if (
        this.subCategoryID === 0 &&
        categoryDetails.subCategoryID !== undefined
      ) {
        this.subCategoryID = categoryDetails.subCategoryID;
      }
    }

    let c_ID = userdata.companyID;
    let s_ID = parseInt(localStorage.getItem('storeId')!);
    let storeId = parseInt(localStorage.getItem('tempStoreId')!);
    if (!storeId) {
      storeId = parseInt(localStorage.getItem('storeId')!);
    }
    let storeCode = parseInt(localStorage.getItem('StoreCode')!);
    this.originalStoreID = storeCode;
    if (this.subCategoryID) {
      this.breadcrumbService.updateActiveSubCategoryTab(
        categoryDetails.subCategoryName
      );
      this.originalsubCtgName = categoryDetails.subCategoryName;
    }
    this.masterservice
      .getSizePricing(
        c_ID,
        departmentIdToUse,
        this.categoryId,
        this.subCategoryID,
        storeId
      )
      .subscribe((result: any) => {
        this.result = result;
        this.sizeButtons = result.item1;

        if (this.sizeButtons.length > 6) {
          this.showMoreSizes = false;
        } else {
          this.showMoreSizes = true;
        }

        if (result.item2.length == 0 || !result.item2) {
          this.chekPrice();
        }
        if (this.sizeButtons.length == 0) {
          this.showPrices = false;
          this.showConditions = false;
          this.showQualityBox = false;
          this.hideSizeGried = false;
        }

        result.item2.sort((a: any, b: any) => {
          return parseFloat(a.price) - parseFloat(b.price);
        });
        this.priceTags = result.item2;

        if (this.priceTags.length > 6) {
          this.showMorePriceTags = false;
        } else {
          this.showMorePriceTags = true;
        }

        this.activeTag = this.priceTags[0]?.printTypeId;
        this.printerType = this.activeTag;
        this.getLabels();
        this.originalDeptName = this.priceTags[0]?.departmentDescr;

        this.selectionlabels = this.priceTags;
        if (this.selectionlabels[0]?.conditionId == null) {
          this.isCondition = true;
        }

        if (this.selectionlabels[0]?.qualityId > 0) {
          this.isPricetype = false;
        }

        this.conditions = result.item2;

        this.conditions.forEach((element: any) => {
          if (element.conditionId === null) {
            this.hideconditionGrid = false;
          }
          element.conditionDescr = element.conditionDescr
            ? element.conditionDescr.replace(/[\r\n\s]+/g, '')
            : '';
        });

        const uniqueConditionIDs = new Set<number>();
        this.conditions = this.conditions.filter((item: any) => {
          if (item.conditionId != null) {
            if (!uniqueConditionIDs.has(item.conditionId)) {
              uniqueConditionIDs.add(item.conditionId);
              this.newConditions.push(item.conditionId);
              return true;
            }
          }
          return false;
        });
        if (uniqueConditionIDs.size > 0) {
          this.priceTags = this.getSmallestConditionEntries(result.item2);
        }
        if (this.sizeButtons.length == 0 && this.newConditions.length) {
          this.showQualityBox = true;
        }
        if (this.sizeButtons.length == 0 && this.newConditions.length == 0) {
          this.showQualityBox = false;
        }
        if (this.sizeButtons.length == 0) {
          this.isSizedNull = true;
        }

        this.priceTags.map((item: any) => {
          let clr = item.GradeColor;
          clr = clr ? clr.replace(/ /g, '') : '';
          clr = clr.toLowerCase();
          item.GradeColor = clr;
        });
        this.priceTagDescrListinEnglish = result.item2.map(
          (button: { qualityDescr: any }) => button.qualityDescr
        );
        const textsToTranslate = this.priceTagDescrListinEnglish;
        this.translateText(textsToTranslate);

        this.conditionsDescrInEnglish = this.conditions.map(
          (condition: { ConditionDescr: any }) => condition.ConditionDescr
        );
        const conditionsDescrToTranslate = this.conditionsDescrInEnglish;
        this.translateConditiondescr(conditionsDescrToTranslate);
      });
  }

  getSmallestConditionEntries(data: any[]): any[] {
    this.priceTags = [];
    const grouped: { [key: number]: any[] } = {};

    data.forEach((item) => {
      if (!grouped[item.qualityId]) {
        grouped[item.qualityId] = [];
      }
      grouped[item.qualityId].push(item);
    });

    const result: any[] = [];

    Object.values(grouped).forEach((group) => {
      const minItem = group.reduce((min: any, current: any) =>
        current.conditionId < min.conditionId ? current : min
      );
      result.push(minItem);
    });

    result.sort((a: any, b: any) => {
      return parseFloat(a.price) - parseFloat(b.price);
    });

    return result;
  }

  reprint() {
    this.reprintMode = !this.reprintMode;
  }

  stayScreen() {
    this.isStayScreen = !this.isStayScreen;
    this.cdr.detectChanges();
  }

  activeFormatTag(tagId: number) {
    this.activeTag = tagId;

    this.formatLabels.map((res) => {
      if (res.id == tagId) {
        this.zplCode = res.zplCode;
        this.printerType = res.printerType;
      }
    });
  }

  getLabels() {
    let userdata = this.masterservice.getUserDetailsFromStorage();
    let c_Id = userdata.companyID;
    this.masterservice.getAllLabels(c_Id).subscribe((res) => {
      const data: Labels[] = Array.isArray(res) ? res : [res];

      this.formatLabels = data.filter(
        (label) => label.labelEntityType === LabelEntityType.Product
      );

      this.labels = this.formatLabels;

      this.formatLabels.map((res) => {
        if (res.id == this.activeTag) {
          this.printerType = res.printerType;
        }
      });
      this.formatLabelsListinEnglish = this.formatLabels.map(
        (label: { name: any }) => label.name
      );
      this.translateText(this.formatLabelsListinEnglish);
    });
  }

  async getBrands() {
    let deptInfo = JSON.parse(localStorage.getItem('deptID')!);
    let deptID = deptInfo.departmentId || deptInfo.departmentId;
    await this.masterservice.getBrandProduction(deptID).subscribe((res) => {
      this.brands = res as BrandModels[];
      this.brands.sort((a, b) =>
        (a?.brandDescr ?? '').localeCompare(b?.brandDescr ?? '')
      );
      this.brandsForSearch = this.brands;
      this.brandsDescrInEnglish = this.brands.map(
        (brand: { brandDescr: any }) => brand.brandDescr
      );
      const brandsDescrToTranslate = this.brandsDescrInEnglish;

      this.translateBranddescr(brandsDescrToTranslate);
    });
  }

  triggerButtonClick() {
    if (this.myButton) {
      this.myButton.nativeElement.click();
    }
  }

  triggerPriceBtn() {
    if (this.checkBtn) {
      this.checkBtn.nativeElement.click();
    }
  }

  triggerTagButtonClick() {
    if (this.tagButton) {
      this.tagButton.nativeElement.click();
    }
  }

  selectBrand(brandName: any, brandId: any) {
    if (brandName == 'None') {
      this.selectedBrandName = 'Select Brand';
      this.selectedBrand = 0;
    } else {
      this.selectedBrandName = brandName;
      this.selectedBrand = brandId;
    }

    this.brands.forEach((res) => {
      if (this.selectedBrand == res.brandId) {
        if (
          res.brandTypeID > 0 &&
          res.brandTypeID != null &&
          res.brandTypeName != 'Sales Floor'
        ) {
          this.triggerButtonClick();
          this.activeBin = res.brandTypeName;
        } else {
          this.showModal = false;
        }
      }
    });
    this.getPrice(this.selectedBrand);
    if (this.selectedBrand == 0) {
      this.inputVal = null;
    }
  }

  searchForBrand() {
    if (this.brandSearch == '') {
      this.brands = this.brandsForSearch;
    } else {
      const filteredBrandsData = this.brands.filter((res: any) => {
        if (res.brandDescr != null) {
          return res.brandDescr
            .toLowerCase()
            .includes(this.brandSearch.toLowerCase());
        } else {
          return false;
        }
      });
      this.brands = filteredBrandsData;
    }
  }

  getSearchResult(event: KeyboardEvent) {
    if (this.brandSearch == '') {
      this.brands = this.brandsForSearch;
    } else if (event.keyCode != 8) {
      this.searchForBrand();
    } else {
      this.brands = this.brandsForSearch;
      this.searchForBrand();
    }
  }

  emptySearchBox() {
    this.brandSearch = '';
    this.brands = this.brandsForSearch;
  }

  getPrice(brandId: any) {
    let details = JSON.parse(localStorage.getItem('deptID')!);
    const departmentId = details.departmentId || details.departmentId;
    const categoryId = details.categoryId || details.categoryId;
    this.masterservice
      .getAIPrice(departmentId, categoryId, brandId)
      .subscribe((res: any) => {
        this.aiPrice = Array.isArray(res) ? res[0] : res;
        const ebayPrice = Number(this.aiPrice?.ebayPrice);
        const poshmarkPrice = Number(this.aiPrice?.poshmarkPrice);
        if (ebayPrice > 0) {
          this.inputVal = ebayPrice.toFixed(2);
        } else if (poshmarkPrice > 0) {
          this.inputVal = poshmarkPrice.toFixed(2);
        } else {
          this.inputVal = '0.00';
        }
      });
  }

  calculateAveragePrice(itemList: any[]): number | null {
    let totalPrice = 0;
    let numItems = 0;

    for (const item of itemList) {
      const priceRange = item.Price.split(' to ');

      if (priceRange.length === 1) {
        const price = parseFloat(priceRange[0].replace('$', ''));
        totalPrice += price;
        numItems++;
      } else if (priceRange.length === 2) {
        const minPrice = parseFloat(priceRange[0].replace('$', ''));
        const maxPrice = parseFloat(priceRange[1].replace('$', ''));
        const averagePrice = (minPrice + maxPrice) / 2;
        totalPrice += averagePrice;
        numItems++;
      }
    }

    if (numItems === 0) {
      return null;
    }

    const average = totalPrice / numItems;
    return average;
  }

  // Method for getting active size button
  activeSizeButton(sizeid: number, size: any, index: any) {
    if (this.sizeButtons[index].NumericSizeRange != null) {
      this.alphasize = size.toString();
      //this.alphasize = this.alphasize + " " + this.sizeButtons[index].NumericSizeRange;
    } else {
      this.alphasize = size.toString();
    }
    this.sizeID = sizeid;
    this.activeButtonIndex = sizeid;
    this.showConditions = false;
    this.checkSubmitValidation();

    this.showPrices = false;
    if (this.conditions.length == 0) {
      this.showQualityBox = false;
      this.checkSubmitValidation();
    }
  }

  selectedCondition(buttonId: number, data: any) {
    if (this.sizeButtons.length == 0) {
      this.showQualityBox = false;
    }

    if (this.showConditions === false) {
      this.showQualityBox = false;
    }
    this.activeCondition = buttonId;
    this.checkSubmitValidation();
    this.priceTags = [];
    this.lablesData = data;

    //translateObject
    this.labelsDataDeptDecrObjInEnglish = this.lablesData.DepartmentDescr;
    this.translateDataDeptDecrObj(this.labelsDataDeptDecrObjInEnglish);

    this.categoryNameObj = this.lablesData.CategoryName;
    this.translateCategoryNameObj(this.categoryNameObj);

    this.result.item2.forEach((element: any) => {
      if (element.conditionId == data.conditionId) {
        this.priceTags.push(element);
      }
    });
  }

  // Method for Saving Data(Using priceTag)
  activePriceTag(buttonId: number, pricedata: any) {
    this.activeQuality = buttonId;
    let storeId = JSON.parse(localStorage.getItem('tempStoreId')!);
    this.checkSubmitValidation();
    let user = this.masterservice.getUserDetailsFromStorage();
    if (!storeId) {
      storeId = JSON.parse(localStorage.getItem('storeId')!);
    }
    this.productionWorking.brandID = this.selectedBrand;
    this.productionWorking.isSpecialPrice = false;
    this.productionWorking.formatTypeId = this.activeTag;
    this.productionWorking.userID = user.userId;
    this.productionWorking.sizeID = this.sizeID;
    this.productionWorking.CategoryID = pricedata.categoryId;
    this.productionWorking.subCategoryID = this.subCategoryID;
    this.productionWorking.CategoryName = pricedata.categoryName;
    this.productionWorking.DepartmentDescr = pricedata.departmentDescr;
    this.productionWorking.company = user.company;
    this.productionWorking.CompanyID = user.companyID;
    this.productionWorking.sizeID = this.sizeID;
    this.productionWorking.isPrint = this.PrintMode;
    [];
    this.productionWorking.CategoryID = pricedata.categoryId;
    this.productionWorking.departmentId = pricedata.departmentId;
    this.productionWorking.price = parseFloat(pricedata.price);
    this.productionWorking.qualityID = pricedata.qualityId;
    this.productionWorking.conditionID = pricedata.conditionId;
    this.productionWorking.sizeDescr = this.alphasize;
    this.productionWorking.CompanyID = user.companyID;
    this.productionWorking.productionStoreId = storeId;
    this.productionWorking.qty = parseFloat(this.quantity);
    this.productionWorking.numberOfPieces = parseFloat(this.piece);
    this.productionWorking.productionCycleID = this.productionCycleID;
    this.productionWorking.productionCycleScheduleID =
      this.productionCycleScheduleID;
    this.productionWorking.addtoBin = this.moveToBin;
    this.productionWorking.isReprint = this.reprintMode;
    this.onProduceClick(this.productionWorking);

    /*
    if (this.reprintMode == false) {
     }
     else {
       this.checkReprint(this.productionWorking);
     }
     */

    if (this.selectedPriceTagId === buttonId) {
      this.selectedPriceTagId = null;
    } else {
      this.selectedPriceTagId = buttonId;
      this.priceTagStatus = pricedata.Price;
    }
  }

  // Method for Saving Data(Using Special price)
  async onSubmit(event: any) {
    // The template passes the raw DOM value, so normalise here rather than relying on blur.
    const normalizedPrice = this.normalizePrice(event) ?? 0;
    this.priceTagStatus = normalizedPrice;
    let pricedata = this.priceTags[0];
    let user = this.masterservice.getUserDetailsFromStorage();
    let colorId = JSON.parse(localStorage.getItem('productionID')!);
    let storeId = JSON.parse(localStorage.getItem('tempStoreId')!);
    if (!storeId) {
      storeId = JSON.parse(localStorage.getItem('storeId')!);
    }
    this.productionWorking.userID = user.userId;
    this.productionWorking.formatTypeId = this.activeTag;
    this.productionWorking.isSpecialPrice = true;
    this.productionWorking.sizeID = this.sizeID;
    this.productionWorking.brandID = this.selectedBrand;
    this.productionWorking.CategoryID = pricedata.categoryId;
    this.productionWorking.subCategoryID = this.subCategoryID;
    this.productionWorking.CategoryName = pricedata.categoryName;
    this.productionWorking.company = user.company;
    this.productionWorking.isPrint = this.PrintMode;
    this.productionWorking.DepartmentDescr = pricedata.departmentDescr;
    this.productionWorking.departmentId = pricedata.departmentId;
    this.productionWorking.sizeDescr = this.alphasize;
    // this.productionWorking.CompanyID = pricedata.CompanyId;
    this.productionWorking.CompanyID = user.companyID;
    this.productionWorking.productionStoreId = storeId;
    this.productionWorking.price = normalizedPrice;
    this.productionWorking.qualityID = pricedata.qualityId;
    this.productionWorking.conditionID = pricedata.conditionId;
    this.productionWorking.qty = parseFloat(this.quantity);
    this.productionWorking.numberOfPieces = parseFloat(this.piece);
    this.productionWorking.productionCycleID = this.productionCycleID;
    this.productionWorking.productionCycleScheduleID =
      this.productionCycleScheduleID;
    //this.productionWorking.productionCycleID = parseInt(colorId, 10);
    this.productionWorking.addtoBin = this.moveToBin;
    this.productionWorking.isReprint = this.reprintMode;
    this.brandname = this.getBrandName(this.selectedBrand);

    this.onProduceClick(this.productionWorking);

    /* if (this.reprintMode == false) {
     } else {
       this.checkReprint(this.productionWorking);
     }*/
  }

  getBrandName(id: number): string {
    const foundBrand = this.brands.find((res) => res.brandId === id);
    if (foundBrand) {
      return foundBrand.brandDescr;
    } else {
      return 'Brand Not Found!';
    }
  }

  async getBrandQty(data: ProductionHistory[]): Promise<number> {
    let qty: number = 0;
    await data.forEach((res) => {
      if (res.brandTypeId == 1) {
        qty++;
      }
    });

    return qty;
  }
  togglePreview(value?: boolean) {
    if (typeof value === 'boolean') {
      this.PrintMode = value;
    } else {
      this.PrintMode = !this.PrintMode;
    }
  }

  private isProcessing = false;
  private isProductionLimitChecked = false;
  pendingProductionData: any;

  checkProductionLimit() {
    this.userInfo = this.masterservice.getUserDetailsFromStorage();
    const productionLimit = this.userInfo.productionLimit || 0;

    if (
      productionLimit > 0 &&
      productionLimit != null &&
      this.quantity > productionLimit
    ) {
      this.productionLimitPopupMsg = `You are producing ${this.quantity} Items, which exceeds the limit of ${productionLimit}. Are you sure you want to continue?`;
      this.productionLimitBtn?.nativeElement.click();
    } else {
      // No popup needed, proceed directly
      this.validateProductionLimit(true);
    }
  }

  validateProductionLimit(shouldProceed: boolean) {
    this.isProductionLimitChecked = shouldProceed;
    if (shouldProceed) {
      // Continue with production only if user confirmed
      this.addProduction(this.pendingProductionData);
    } else {
    }
  }

  onProduceClick(data: any) {
    // Snapshot the submission. `this.productionWorking` is a single shared
    // object reused across submissions; a later submission (or the
    // production-limit popup gap) can mutate it before this one is sent.
    // Cloning here pins this submission's values (incl. price) to its barcode.
    this.pendingProductionData = { ...data };
    this.checkProductionLimit();
  }
  addProduction(data: any) {
    try {
      this.resetButtons();

      if (this.isProcessing) {
        this.toastr.process('Processing...');
        return;
      }
      const department = data.DepartmentDescr || data.departmentDescr || '';
      const category = data.CategoryName || data.categoryName || '';

      this.isProcessing = true;

      if (this.PrintMode) {
        const zplCode = this.generatePreviewZpl(
          data.company,
          department,
          category,
          'Size: ',
          data.sizeDescr || '',
          Number(data.price).toFixed(2),
          '1324|1321',
          ' ',
          data.qualityID,
          this.selectedBrandName
        );
        this.generatePreview(zplCode);
        this.triggerTagButtonClick();
        this.isProcessing = false;
        return;
      }

      if (data.price) {
        const productionforDt = localStorage.getItem('WeekDate');
        const futproductionCycle = localStorage.getItem(
          'FutureProductionCycle'
        );
        const LocationID = localStorage.getItem('CurrentLocationID');

        if (futproductionCycle) {
          const parsedProductionCycle = JSON.parse(futproductionCycle);
          data.productionCycleScheduleID =
            parsedProductionCycle.productionCycleScheduleId;
          data.productionCycleID = parsedProductionCycle.productionCycleId;
        }

        const user = this.masterservice.getUserDetailsFromStorage();
        const productionScheduleType = (
          user?.productionScheduleType ??
          this.userDetails?.productionScheduleType ??
          ''
        )
          .toString()
          .trim()
          .toLowerCase();

        if (productionScheduleType === 'datespecific') {
          data.productionCycleID = null;
        }

        if (LocationID) {
          const parsedLocationID = Number(JSON.parse(LocationID));
          data.currentLocationID =
            data.currentLocationID > 0
              ? data.currentLocationID
              : parsedLocationID;
        }

        data.productionforDt = productionforDt
          ? (() => {
            const now = new Date();
            const d = new Date(productionforDt + 'T00:00:00');
            d.setHours(
              now.getHours(),
              now.getMinutes(),
              now.getSeconds(),
              now.getMilliseconds()
            );
            return d.toISOString();
          })()
          : new Date().toISOString();

        const currentStoreId = JSON.parse(localStorage.getItem('storeId')!);
        data.currentStoreId = currentStoreId;
        const currentStationId = JSON.parse(localStorage.getItem('stationId')!);
        data.stationId = currentStationId;
        data.isProductEventsEnabled = user.apps.some(
          (app) => app.id === Apps.POS
        );
        const metadata = JSON.parse(
          localStorage.getItem('productionMetadata')!
        );
        data.lotId = metadata?.lotId ?? 0;
        data.currentLocationID =
          !data.currentLocationID || Number(data.currentLocationID) === 0
            ? (metadata?.salesFloorLocationId ?? 0)
            : data.currentLocationID;
        const freshOverrideDetails = JSON.parse(localStorage.getItem('overrideDetails') || '{}');
        data.licensePlateId = freshOverrideDetails?.licensePlateId || 0;
        if (freshOverrideDetails?.licensePlateStoreId) {
          data.productionStoreId = freshOverrideDetails.licensePlateStoreId;
        }
        data.sourceContainerId = this.sourceBinId ? this.sourceBinId : 0;
        const sub = this.masterservice.addProductionWorking(data).subscribe({
          next: (res: any) => {
            this.showSuccess();
            this.breadcrumbService.increment(this.quantity);
            const createdItems = (res || []) as Array<{ barcode: string }>;
            // Bump the license plate's cached item count whenever a plate is
            // assigned, whether it came from a production override or a
            // plain scan with no override association.
            try {
              const lpId = data.licensePlateId;
              const addedQty = Number(this.quantity) || 0;
              if (lpId) {
                const key = `licensePlateCount_${lpId}`;
                const prev =
                  parseInt(localStorage.getItem(key) || '0', 10) || 0;
                const updated = prev + addedQty;
                localStorage.setItem(key, updated.toString());
                localStorage.setItem('licensePlateCount', updated.toString());
                window.dispatchEvent(
                  new CustomEvent('licensePlateCountUpdated', {
                    detail: { licensePlateId: lpId, count: updated }
                  })
                );
              }
            } catch (e) { }

            this.handleProductionSuccess(createdItems, data);

            setTimeout(() => {
              this.priceTagBtn?.nativeElement.click();
              this.closeBtn?.nativeElement.click();
              if (!this.isStayScreen) {
                this.route.navigateByUrl('/home/departments');
              }
            }, 1000);
          },
          error: (err) => {
            this.showError();
            this.isProcessing = false;
            sub.unsubscribe();
          },
          complete: () => {
            this.isProcessing = false;
            sub.unsubscribe();
          }
        });
      } else {
        // No request will be fired; release the guard.
        this.isProcessing = false;
      }
    } catch (error) {
      // Release the guard only on a synchronous failure. Do NOT reset in a
      // finally block: the POST above is async, so a finally runs before the
      // response arrives and would defeat the duplicate-submit guard,
      // allowing overlapping submissions when the API is slow.
      this.isProcessing = false;
    }
  }

  async handleProductionSuccess(
    createdItems: Array<{ barcode: string }>,
    productionData: any
  ) {
    const barcodes = (createdItems || [])
      .map((item) => item?.barcode)
      .filter((barcode): barcode is string => !!barcode && barcode.length > 0);

    const sizeDescr = productionData?.sizeDescr || this.alphasize || '';
    const priceValue = Number(productionData?.price ?? 0);
    const safePrice = Number.isFinite(priceValue) ? priceValue : 0;
    const piecesValue = Number(
      productionData?.numberOfPieces ?? this.piece ?? 1
    );
    const safePieces =
      Number.isFinite(piecesValue) && piecesValue > 0 ? piecesValue : 1;
    const categoryName =
      productionData?.CategoryName ||
      productionData?.categoryName ||
      this.originalCtgName ||
      '';
    const departmentDescr =
      productionData?.DepartmentDescr ||
      productionData?.departmentDescr ||
      this.originalDeptName ||
      '';

    this.printHistory = barcodes.map(
      (barcode) =>
        ({
          barcode,
          sizeDescr,
          price: safePrice,
          dateCreated: new Date().toISOString(),
          numberOfPieces: safePieces,
          categoryName,
          departmentDescr,
          formatTypeId: this.activeTag
        }) as ProductionHistory
    );

    try {
      const allPrintData: any[] = [];
      this.printHistory.forEach((item, barcodeIndex) => {
        item.brandDescr = this.selectedBrandName;

        for (let copyIndex = 0; copyIndex < this.piece; copyIndex++) {
          if (!this.PrintMode) {
            const zplData = this.generateZpl(
              this.userDetails.company,
              this.originalDeptName,
              this.originalCtgName,
              this.originalsubCtgName,
              'Size:',
              item.sizeDescr,
              item.price.toFixed(2).toString(),
              item.barcode,
              this.originalStoreID,
              this.activeQuality,
              (copyIndex + 1).toString(),
              safePieces.toString(),
              item.brandDescr
            );

            allPrintData.push(...zplData);
          } else {
            this.tagClr = 'Pink';
            this.tagCtg = item.categoryName;
            this.tagDept = item.departmentDescr;
            this.tagSize = item.sizeDescr;
            this.tagPrice = item.price.toString();
            this.SerialId = item.barcode;
            this.tagID = item.formatTypeId;
          }
        }
      });
      const userdata = this.masterservice.getUserDetailsFromStorage();
      if (
        allPrintData.length > 0 &&
        !this.PrintMode &&
        userdata.productionAutoPrint
      ) {
        await this.printLabelBatch(allPrintData);
      }

      this.resetButtons();
      this.resetParameters();
    } catch (error) {
      console.error(error);
    }
  }

  async printLabelBatch(printDataArray: any[]): Promise<void> {
    let printerName: string = '';

    if (this.printerType == 1) {
      printerName = 'ZebraLabel';
    } else if (this.printerType == 2) {
      printerName = 'ZebraTag';
    } else if (this.printerType == 3) {
      printerName = 'ZebraBoth';
    }

    try {
      await this.printService.printDataBatch(printerName, printDataArray);
      console.log(`Batch printed ${printDataArray.length} labels successfully`);
    } catch (error) {
      console.error('Batch printing failed:', error);
      for (const printData of printDataArray) {
        try {
          await this.printService.printData(printerName, [printData]);
        } catch (individualError) {
          console.error('Individual print failed:', individualError);
        }
      }
    }
  }

  resetButtons() {
    const shouldShow =
      this.sizeButtons.length != 0 || this.newConditions.length != 0;
    this.showPrices = this.showQualityBox = this.showConditions = shouldShow;
    this.showQualityBox =
      this.showQualityBox =
      this.showConditions =
      shouldShow;
    this.checkSubmitValidation();

    if (!shouldShow) {
      setTimeout(() => {
        this.showPrices = this.showQualityBox = this.showConditions = false;
        this.checkSubmitValidation();
      }, 1000);
    }
    if (this.newConditions.length > 0 && this.sizeButtons.length == 0) {
      this.showConditions = false;
    }
  }
  resetParameters() {
    this.showSuccess();
    if (this.keepSelection) {
      this.showQualityBox = this.showConditions = this.showPrices = false;
      this.checkSubmitValidation();
      this.selectedPriceTagId = null;
      this.priceTagStatus = null;
      this.inputValue = '';
      this.selectedBrand = 0;
      this.inputVal = null;
      this.moveToBin = false;
      this.activeQuality = 0;
    } else {
      this.selectedPriceTagId = null;
      this.activeCondition = 0;
      this.priceTagStatus = null;
      this.activeQuality = 0;
      this.activeButtonIndex = 0;
      this.inputValue = '';
      this.selectedBrand = 0;
      this.inputVal = null;
      this.moveToBin = false;
      this.quantity = 1;
    }
  }

  generateZPLData(index: number, data: ProductionHistory, labelIndex: number) {
    if (
      typeof this.originalStoreID === 'number' &&
      !isNaN(this.originalStoreID)
    ) {
      this.originalStoreID = this.originalStoreID.toString();
    }

    let store = JSON.parse(localStorage.getItem('storeId')!);

    let zplData = this.generateZpl(
      this.userDetails.company,
      this.originalDeptName,
      this.originalCtgName,
      this.originalsubCtgName,
      'Size:',
      data.sizeDescr,
      data.price.toFixed(2).toString(),
      data.barcode,
      this.originalStoreID,
      this.activeQuality,
      '1',
      '1',
      data.brandDescr
    );
    console.log('ZPL Data:', zplData);
    this.printLabel(zplData);
    this.resetButtons();
  }

  async delWorkingTbl(workingTbl: number) {
    this.masterservice.delHistory([workingTbl.toString()]).subscribe((res) => {
      this.breadcrumbService.decrement(1);
      this.showDeleted();
    });
  }

  translateLabelsData(): void {
    this.dynamicTranslationService
      .translateObject(this.lablesData.DepartmentDescr)
      .subscribe((translatedDepartmentDescr: string) => {
        this.lablesData.DepartmentDescr = translatedDepartmentDescr;
      });

    this.dynamicTranslationService
      .translateObject(this.lablesData.CategoryName)
      .subscribe((translatedCategoryName: string) => {
        this.lablesData.CategoryName = translatedCategoryName;
      });
  }

  //Translation logic:
  updateWaresContent(): void {
    /*this.dynamicTranslationService.translateText(this.priceTagDescrListinEnglish).subscribe((translatedDescriptions: string[]) => {
      this.priceTags.forEach((button: { QualityDescr: string; }, index: number) => {
        button.QualityDescr = translatedDescriptions[index];

      });
    });*/
  }

  translateText(inputText: any) {
    /* this.dynamicTranslationService.translateText(inputText).subscribe((translatedTexts: string[]) => {
       if (inputText == this.priceTagDescrListinEnglish)
         this.updateWaresContent();
       else if (inputText == this.priceTagDescrListinEnglish) {
         this.updateconditiondescr();
       }

     });*/
  }

  //Translation logic:FormatTypeDescrp
  updateFormatTypeDescrpContent(): void {
    /*  this.dynamicTranslationService.translateText(this.formatLabelsListinEnglish).subscribe((translatedDescriptions: string[]) => {
        this.formatLabels.forEach((label, index) => {
          label.name = translatedDescriptions[index];
        });
      });*/
  }

  translateFormatTypeDescrp(inputText: any) {
    this.dynamicTranslationService
      .translateText(inputText)
      .subscribe((translatedTexts: string[]) => {
        this.updateFormatTypeDescrpContent();
      });
  }

  //Translation logic:LabelsDataCategoryName
  updateLabelsDataCategoryName(): void {
    this.dynamicTranslationService
      .translateText(this.labelsDataDeptDecrInEnglish)
      .subscribe((translatedDescriptions: string[]) => {
        /*this.lablesData.forEach((label: { CategoryName: string; }, index: number) => {
        label.CategoryName = translatedDescriptions[index];
      });*/
      });
  }

  translateLabelsDataCategoryName(inputText: any) {
    this.dynamicTranslationService
      .translateText(inputText)
      .subscribe((translatedTexts: string[]) => {
        this.updateLabelsDataCategoryName();
      });
  }
  //Translation logic:DataDeptDecr

  updateDataDeptDecrObj(): void {
    /*  this.dynamicTranslationService.translateObject(this.labelsDataDeptDecrObjInEnglish)
        .subscribe((translatedText: string) => {
          this.lablesData.DepartmentDescr = translatedText;
        });*/
  }

  translateDataDeptDecrObj(inputText: string) {
    /*   this.dynamicTranslationService.translateObject(inputText)
         .subscribe((translatedText: string) => {
           this.updateDataDeptDecrObj();
         });*/
  }
  //Translation logic:CategoryName

  updateCategoryNameObj(): void {
    /* this.dynamicTranslationService.translateObject(this.categoryNameObj)
       .subscribe((translatedText: string) => {
         this.lablesData.CategoryName = translatedText;
       });*/
  }

  translateCategoryNameObj(inputText: string) {
    /*  this.dynamicTranslationService.translateObject(inputText)
        .subscribe((translatedText: string) => {
          this.updateCategoryNameObj();
        });*/
  }
  //Translation logic:FormatValue

  translateFormatValue(inputText: string) {
    /*  this.dynamicTranslationService.translateObject(inputText)
        .subscribe((translatedText: string) => {
        });*/
  }

  //Translation logic:ConditionDescr
  updateconditiondescr(): void {
    /*this.dynamicTranslationService.translateText(this.conditionsDescrInEnglish).subscribe((translateddescriptions: string[]) => {
      this.conditions.forEach((label: { ConditionDescr: string; }, index: number) => {
        label.ConditionDescr = translateddescriptions[index];
      });
    });*/
  }

  translateConditiondescr(inputtext: any) {
    /*  this.dynamicTranslationService.translateText(inputtext).subscribe((translatedtexts: string[]) => {

        this.updateconditiondescr();
      });*/
  }

  //*Translation logic:Branddescr

  updateBrandDescr(): void {
    this.dynamicTranslationService
      .translateText(this.brandsDescrInEnglish)
      .subscribe((translateddescriptions: string[]) => {
        this.brands.forEach((brand: { brandDescr: string }, index: number) => {
          brand.brandDescr = translateddescriptions[index];
        });
      });
  }

  translateBranddescr(inputtext: any) {
    this.dynamicTranslationService
      .translateText(inputtext)
      .subscribe((translatedtexts: string[]) => {
        this.updateBrandDescr();
      });
  }

  updateNavContent(translatedNames: string | string[]): void {
    if (Array.isArray(translatedNames)) {
    } else {
      this.translatedFormatValue = translatedNames;
    }
  }

  translateTextTitle(textOrTexts: string) {
    const textsToTranslate = Array.isArray(textOrTexts)
      ? textOrTexts
      : [textOrTexts];
    this.dynamicTranslationService
      .translateText(textsToTranslate)
      .subscribe((translatedTexts: string[]) => {
        if (typeof textOrTexts === 'string') {
          if (translatedTexts.length > 0) {
            const translatedText = translatedTexts[0];
            this.abd = translatedText;
            // Assuming you want the first translated text
          }
        }
        if (Array.isArray(textOrTexts)) {
          this.translatedTexts = translatedTexts;
        } else {
          // Handle single translated string here
          const translatedString = translatedTexts[0]; // Assuming there's only one translated string
        }
      });
  }

  translateCtgTitle(textOrTexts: string) {
    const textsToTranslate = Array.isArray(textOrTexts)
      ? textOrTexts
      : [textOrTexts];
    this.dynamicTranslationService
      .translateText(textsToTranslate)
      .subscribe((translatedTexts: string[]) => {
        if (typeof textOrTexts === 'string') {
          if (translatedTexts.length > 0) {
            const translatedText = translatedTexts[0];
            this.ctg = translatedText;
            // Assuming you want the first translated text
          }
        }
        if (Array.isArray(textOrTexts)) {
          this.translatedTexts = translatedTexts;
        } else {
          // Handle single translated string here
          const translatedString = translatedTexts[0]; // Assuming there's only one translated string
        }
      });
  }

  checkPriceNotEmpty() {
    if (this.inputVal) {
      this.inputVal = this.inputVal
        .replace(/[^0-9.]/g, '')
        .replace(/(\..*)\./g, '$1')
        .replace(/^(\d+)(\.\d{0,2}).*$/, '$1$2');
    }

    this.checkSubmitValidation();
  }

  /**
   * Commits a manually typed "open price" to 2 decimal places.
   * No decimal typed -> last two digits are cents once there are 3+ digits
   *   ('599' -> 5.99, '500' -> 5.00, '49999' -> 499.99); 1-2 digits are read
   *   as a whole-dollar amount ('5' -> 5.00) rather than shifted into cents.
   * Decimal typed    -> kept as entered, padded to 2 places ('5.9' -> 5.90).
   * Returns null when the value is empty or unparseable.
   */
  normalizePrice(raw: any): number | null {
    const sanitized = (raw ?? '')
      .toString()
      .replace(/[^0-9.]/g, '')
      .replace(/(\..*)\./g, '$1');

    if (!sanitized || sanitized === '.') return null;

    let value: number;
    if (sanitized.includes('.')) {
      value = parseFloat(sanitized);
    } else if (sanitized.length <= 2) {
      value = parseInt(sanitized, 10);
    } else {
      value = parseFloat(`${sanitized.slice(0, -2)}.${sanitized.slice(-2)}`);
    }

    return isNaN(value) ? null : Math.round(value * 100) / 100;
  }

  /** Formats the Other Price field once the associate leaves it, so the decimal is always shown. */
  onPriceBlur(el: HTMLInputElement): void {
    const value = this.normalizePrice(this.inputVal);
    if (value === null) return;

    this.inputVal = value.toFixed(2);
    // The template submits el.value (the raw DOM value), so keep it in sync with the model.
    if (el) {
      el.value = this.inputVal;
    }

    this.checkSubmitValidation();
  }

  checkSubmitValidation() {
    let isValid = true;

    // Price validation
    const priceNum = this.normalizePrice(this.inputVal) ?? NaN;
    if (
      !this.inputVal ||
      isNaN(priceNum) ||
      priceNum <= 0 ||
      priceNum > 9999.99
    ) {
      isValid = false;
      if (priceNum > 9999.99) {
        this.toastr.error('Price should be less than 9999.99');
      }
    }

    // Size validation
    if (this.sizeButtons && this.sizeButtons.length > 0) {
      if (!(this.activeButtonIndex > 0)) {
        isValid = false;
      }
    }

    // Condition validation
    if (this.conditions && this.conditions.length > 0) {
      if (!(this.activeCondition > 0)) {
        isValid = false;
      }
    }

    this.showSubmit = !isValid;
  }

  generatePreview(zplCode: any) {
    this.labelImg = this.labelaryService.convertZplToPng1(
      zplCode,
      this.previewTagSize
    );
  }

  extractLabelSize(input: string): string {
    const labelNumber = input.match(/[0-9]+(\.[0-9]+)?/)?.[0] || '';
    const sizeNumber = input.match(/[Xx]\s*([0-9]+(\.[0-9]+)?)"/)?.[1] || '';

    let result = `${labelNumber}x${sizeNumber}`;
    result = this.reverseString(result);
    return result;
  }
  reverseString(inputStr: string): string {
    const parts: string[] = inputStr.split('x');
    const reversedStr: string = parts.reverse().join('x');
    return reversedStr;
  }

  getPermissionsByUserId() {
    this.userservice.getUserRolesandPerm().then((res) => {
      let permissions = res as UserPermissionsModel[];

      let perm: string[] = [];

      permissions?.forEach((pr) => {
        perm.push(pr.name);
      });

      this.permissionService.loadPermissions(perm);
    });
  }

  async addItemsToLicensePlate(): Promise<void> {
    this.licensePlateItem.companyId = this.productionWorking.CompanyID;
    const overrideDetails = JSON.parse(localStorage.getItem('overrideDetails') || '{}');
    this.licensePlateItem.label = overrideDetails.overrideDesc;
    this.licensePlateItem.licensePlateId = overrideDetails.licensePlateId;
    this.licensePlateItem.isSerialized = true;
    this.licensePlateItem.productId = this.productionWorking.workingTableID;
    this.licensePlateItem.type = 1;

    let result = await lastValueFrom(
      this.masterservice.getItemOfLicensePlate(
        this.licensePlateItem.licensePlateId
      )
    );

    const currentObj = Array.isArray(result) ? result[0] : result;

    if (currentObj) {
      this.licensePlateItem.quantity =
        this.productionWorking.qty + currentObj.quantity;
      try {
        const res = await lastValueFrom(
          this.masterservice.updateItemToLicensePlate(
            this.licensePlateItem.licensePlateId,
            currentObj.id,
            this.licensePlateItem
          )
        );
        if (res) {
          this.licensePlateItem = res as LicenseplateItems;
          this.itemSerialNumber.licensePlateItemId = this.licensePlateItem.id;
          // increment cached license plate count by produced qty
          try {
            const lpId = this.licensePlateItem.licensePlateId;
            const addedQty = Number(this.productionWorking.qty) || 0;
            const key = `licensePlateCount_${lpId}`;
            const prev = parseInt(localStorage.getItem(key) || '0', 10) || 0;
            const updated = prev + addedQty;
            localStorage.setItem(key, updated.toString());
            localStorage.setItem('licensePlateCount', updated.toString());
            window.dispatchEvent(
              new CustomEvent('licensePlateCountUpdated', {
                detail: { licensePlateId: lpId, count: updated }
              })
            );
          } catch (e) {
            // ignore
          }
        }
      } catch (err) {
        console.error('Error adding item to LP:', err);
      }
    } else {
      this.licensePlateItem.quantity = this.productionWorking.qty;
      this.licensePlateItem.type = 1;
      try {
        const res = await lastValueFrom(
          this.masterservice.addItemToLicensePlate(
            this.licensePlateItem.licensePlateId,
            this.licensePlateItem
          )
        );

        if (res) {
          this.licensePlateItem = res as LicenseplateItems;
          this.itemSerialNumber.licensePlateItemId = this.licensePlateItem.id;
          // increment cached license plate count by produced qty
          try {
            const lpId = this.licensePlateItem.licensePlateId;
            const addedQty = Number(this.productionWorking.qty) || 0;
            const key = `licensePlateCount_${lpId}`;
            const prev = parseInt(localStorage.getItem(key) || '0', 10) || 0;
            const updated = prev + addedQty;
            localStorage.setItem(key, updated.toString());
            localStorage.setItem('licensePlateCount', updated.toString());
            window.dispatchEvent(
              new CustomEvent('licensePlateCountUpdated', {
                detail: { licensePlateId: lpId, count: updated }
              })
            );
          } catch (e) {
            // ignore
          }
        }
      } catch (err) { }
    }
  }
  async addSerialNumber() {
    await this.addItemsToLicensePlate();
    this.printHistory.forEach((obj) => {
      this.itemSerialNumber.serialNumber = obj.barcode;
      this.masterservice
        .addSerialNumberToItem(
          this.licensePlateItem.licensePlateId,
          this.itemSerialNumber.licensePlateItemId,
          this.itemSerialNumber
        )
        .subscribe((res) => { });
    });
  }

  validatePositive(event: any): void {
    const input = event.target;
    if (+input.value < 1) {
      input.value = '';
      this.toastr.error('Please enter a positive number greater than 0');
    }
  }
}
